module.exports = __webpack_public_path__ + "static/media/ig6.e9eec204.jpg";